import { Component } from '../base/component';
import { ensureElement } from '../../utils/utils';
export class CompleteOrder extends Component {
    constructor(container, events) {
        super(container);
        this._exitButton = ensureElement('.order-success__close', container);
        this._total = ensureElement('.order-success__description', container);
        this._exitButton.addEventListener('click', events.onClick);
    }
    set total(value) {
        this.setText(this._total, `Списано ${value} синапсов`);
    }
}
